import React, { useState, useEffect, useRef } from 'react';
import TStyles from '../styles/TestStyles.module.css';
import GenStyles from "../styles/GenStyles.module.css";
import QuestionTimer from "./QuestionTimer";
import LoadingGif from "../images/loading.gif";
import avatarImg from '../images/ai_speaker_image_transparent.png';
import avatarThinking from "../images/ai_speaker_thinking.png";
import avatarListening from "../images/ai_speaker_listening.png";
import speechBubble from "../images/thought_bubble.png";
import AudioRecorder from "../AudioRecorder";
import LoadingBlock from "./LoadingBlock";

const WritingTestInterface = ( { state, questionTotalTime, questionTimeRemaining, question, handleAudioPlaybackStopped, saveResponse } ) => {
    //const [state, setState] = useState('thinking'); // 'thinking', 'speaking', 'recording'
    const [recordingTimeLeft, setRecordingTimeLeft] = useState(questionTimeRemaining);
    const [totalTestTime, setTotalTestTime] = useState(0);
    const questionTextRef = useRef();
    const [audioUrl, setAudioUrl] = useState(null);
    const [answer, setAnswer] = useState("");
    const latestAnswerRef = React.useRef("");
    const [isLoading, setIsLoading] = useState(false);


    // Question Timer Data
    const onElapsed = React.useCallback(() => {
        if (elapsedFiredRef.current) return;
        elapsedFiredRef.current = true;

        // Save the Response
        saveResponse(latestAnswerRef.current);
        setIsLoading(true);

    }, [saveResponse]);

    const [questionRemainingMs, setQuestionRemainingMs] = useState(0);
    const endTimeRef = React.useRef(null);  // timestamp (ms) when timer ends
    const rafRef = React.useRef(null);      // requestAnimationFrame id
    const elapsedFiredRef = React.useRef(false); // ensure onElapsed runs once

    // Simulate total test time counter
    useEffect(() => {

    }, []);

    React.useEffect(() => {
        latestAnswerRef.current = answer;
    }, [answer]);

    // Simulate countdown when recording
    useEffect(() => {
        if (state === 'recording' && recordingTimeLeft > 0) {
            const timer = setTimeout(() => {
                setRecordingTimeLeft(prev => prev - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [state, recordingTimeLeft]);
    useEffect(() => {
        // Clear the text box
        setAnswer("");


        if(question && totalTestTime === 0) {
            startTestOverallTimer();
        }

        if(question && question['question_audio_url']) {
            const url = '/ali_api/ALIAudioStreamer.php?filename=' + question['question_audio_url'] + "&t=" + Date.now();
            setAudioUrl(url);
        }

        // Start the Question Timer
    }, [question])

    useEffect(() => {
        if(question) {
            console.log("Question timer started");
            startQuestionTimer();
        }
    }, [question]);

    //Start playing audio if an audio URL is Supplied
    // useEffect(() => {
    //     if(audioUrl) {
    //         //console.log(audioUrl);
    //         let player = document.getElementById('audio_player');
    //         player.src = audioUrl;
    //         player.play();
    //
    //         // Function to call when playback has ended
    //         const handleEnded = () => {
    //             onQuestionAudioPlaybackEnded();
    //         };
    //
    //         // Add event listener
    //         player.addEventListener('ended', handleEnded);
    //
    //         //If there is question text, start smooth scroll to bottom
    //         if(questionTextRef.current) {
    //             smoothScrollToBottom(questionTextRef.current, 47); // Scroll to bottom in 5 seconds
    //         }
    //
    //         // Cleanup
    //         return () => {
    //             player.removeEventListener('ended', handleEnded);
    //         };
    //     }
    // }, [audioUrl])



    //Other Functions
    function startTestOverallTimer() {
        const interval = setInterval(() => {
            setTotalTestTime(prev => prev + 1);
        }, 1000);

        return () => clearInterval(interval);
    }

    function startQuestionTimer() {
        setIsLoading(false);

        // Calculate the totalMs from seconds allotted * 1000
        const totalMs = question.answer_time_allowed * 1000;

        // Reset "elapsed fire" gate for a new question
        elapsedFiredRef.current = false;

        // Edge case: no time
        if (!totalMs || totalMs <= 0) {
            setQuestionRemainingMs(0);
            onElapsed();
            return;
        }

        // Establish an absolute end time to avoid drift
        const now = Date.now();
        endTimeRef.current = now + totalMs;

        // Prime UI immediately
        setQuestionRemainingMs(totalMs);

        // RAF loop for smooth updates; throttles gracefully in background tabs
        const tick = () => {
            const remaining = Math.max(0, endTimeRef.current - Date.now());
            setQuestionRemainingMs(remaining);

            if (remaining === 0) {
                onElapsed();
                rafRef.current = null; // stop
                return;
            }
            rafRef.current = requestAnimationFrame(tick);
        };

        rafRef.current = requestAnimationFrame(tick);

        // Cleanup on unmount or when question changes
        return () => {
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        };
    }

    //For displaying total test time and question time remaining (if applicable)
    function formatSecondsToMinutesAndSeconds(totalSeconds) {
        // Calculate minutes and remaining seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Format the minute part with proper singular/plural
        const minuteText = minutes === 1 ? "1 minute" : `${minutes} minutes`;

        // Format the second part with proper singular/plural
        const secondText = seconds === 1 ? "1 second" : `${seconds} seconds`;

        // Handle special case of zero minutes
        if (minutes === 0) {
            return secondText;
        }

        // Handle special case of zero seconds
        if (seconds === 0) {
            return minuteText;
        }

        // Combine minutes and seconds
        return `${minuteText} ${secondText}`;
    }



    // const renderStateIndicator = () => {
    //     switch (state) {
    //         case 'thinking':
    //             return <div className={TStyles.thinking_bubble}>Thinking<span className={TStyles.ellipsis}>...</span></div>
    //         case 'recording':
    //             return <div className={TStyles.recording_bubble}>Recording<span className={TStyles.ellipsis}>...</span></div>
    //         case 'speaking':
    //             return <div className={TStyles.speaking_bubble}><span className={TStyles.ellipsis}>...</span>Speaking</div>
    //         default:
    //             return <></>;
    //     }
    // }
    // const renderWaveFormVisualizer = () => {
    //     switch (state) {
    //         case 'recording':
    //             return <div className={state === 'speaking' || state === 'recording' ? TStyles.waveform_active : TStyles.waveform_idle}>WAV</div>
    //         case 'speaking':
    //             return <div className={state === 'speaking' || state === 'recording' ? TStyles.waveform_active : TStyles.waveform_idle}>WAV</div>
    //         default:
    //             return <></>;
    //     }
    // }

    //Makes scrolling of the question text start and end gradually
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    //If the question text is too large for the display box, scroll it
    function smoothScrollToBottom(element, duration) {
        const start = element.scrollTop;
        const end = element.scrollHeight - element.clientHeight;
        const distance = end - start;

        if (distance <= 0) return; // Already at bottom

        const startTime = performance.now();

        function step(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / (duration * 1000), 1); // duration in seconds -> milliseconds

            const easedProgress = easeInOutQuad(progress);

            element.scrollTop = start + distance * easedProgress;

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    //Handles playback of the question audio (triggering recording start in the parent component)
    const onQuestionAudioPlaybackEnded = () => {
        console.log("Playback finished.");
        handleAudioPlaybackStopped();
    }

    //Format the question text... converting line breaks (\n) to paragraphs (<p></p>)
    const formatQuestionText = () => {
        if(!question || !question['question_text']) {
            return '';
        }

        return question['question_text'].split("\n").map((line, index) => (
            <p key={index}>{line.trim()}</p>
        ));
    }
    //Quick function to check whether question_text exists
    const isQuestionText = () => {
        return (question && question['question_text']);
    }




    return (
        <div className={question ? TStyles.testInterface : GenStyles.hidden}>
            {/* State indicator (thought bubble) */}
            {/*<div className={`${TStyles.state_indicator} ${state === 'thinking' ? TStyles.thinking_state : state === 'speaking' ? TStyles.speaking_state : TStyles.recording_state}`}>*/}
            {/*    {renderStateIndicator()}*/}
            {/*</div>*/}

            {/* AI Avatar */}
            {/*<img src={state === 'speaking' ? avatarImg : state === 'recording' ? avatarListening : avatarThinking} alt="AI Avatar" className={TStyles.avatar_image} />*/}

            {/* Timers */}
            <div className={TStyles.timer_container}>

                {/* Progress Bar Countdown for Recording Time Remaining */}

                <div className={TStyles.progress_bar_wrapper}>
                    {state === 'recording' ? (
                        <div
                            className={TStyles.progress_bar_fill}
                            style={{ width: `${(questionTimeRemaining / questionTotalTime) * 100}%` }}
                        ></div>
                    ) : ''}
                </div>

                {/* Question Text */}
                {isLoading ? <LoadingBlock /> :
                    <div
                        className={
                            (isQuestionText() && state !== 'thinking') ?
                                TStyles.writing_question_text :
                                GenStyles.hidden}
                        ref={questionTextRef}
                    >
                        {isQuestionText() ? formatQuestionText() : ''}
                    </div>
                }

                {/* Answer Box */}
                <div className={question ? TStyles.writing_answer_box_holder : GenStyles.hidden}>
                    <label htmlFor="answer_box" className={GenStyles.hidden}>Your answer</label>
                    <textarea
                        id="answer_box"
                        className={TStyles.writing_answer_box}
                        spellCheck={false}
                        autoCorrect="off"
                        autoCapitalize="off"
                        autoComplete="off"
                        placeholder="Type your answer here…"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        aria-describedby="answer_box_hint"
                        disabled={isLoading}
                    />

                    <div className={TStyles.writing_answer_toolbar}>
                        <div id="answer_box_hint" className={TStyles.writing_answer_hint}>
                            Spellcheck is disabled for this test.
                        </div>
                        <div className={TStyles.writing_answer_counter}>
                            {answer.trim() === "" ? "0 words" : `${answer.trim().split(/\s+/).length} words`} · {answer.length} chars
                        </div>
                    </div>

                </div>

                <QuestionTimer
                    totalMs={question?.answer_time_allowed * 1000}
                    remainingMs={questionRemainingMs}
                />



                {/* Total Test Time */}
                <div
                    className={question ? TStyles.total_timer : GenStyles.hidden}
                >Total Time: {formatSecondsToMinutesAndSeconds(totalTestTime)}</div>


            </div>

            <div>
                {audioUrl && (
                    <audio
                        className={TStyles.audio_interface_hidden}
                        controls
                        autoPlay
                        id="audio_player"
                        //onEnded={handle_ai_finished_talking}
                    >
                        <source src={audioUrl} type="audio/mpeg" />
                        Your browser does not support the audio tag.
                    </audio>
                )}
            </div>



        </div>
    )



};

export default WritingTestInterface;